import { FC } from 'react';

import { MICROCOPY } from 'src/data/microcopy/microcopyDictionary';
import { BadgeIllustration } from 'src/general/components/BadgeIllustration/BadgeIllustration';
import { BADGE } from 'src/general/components/BadgeIllustration/BadgeIllustration.type';
import { getMicrocopy } from 'src/stores/microcopyStore';

import styles from './PromoPillBanner.module.scss';

interface PromoPillBannerProps {}

export const PromoPillBanner: FC<PromoPillBannerProps> = () => {
  return (
    <section className={styles.root}>
      <div className={styles.contentContainer}>
        <div className={styles.content}>
          <BadgeIllustration
            background="none"
            shape="square"
            icon={BADGE.WARRANTY}
            className={styles.badgeIllustration}
          />
          <div className={styles.textContainer}>{getMicrocopy(MICROCOPY.PROMO_4_BANNER, true)}</div>
        </div>
      </div>
    </section>
  );
};
